module.exports = require("@swa-ui/personal-info/src/form/NameFormFields/NameFormFields.module.scss");